var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShowEyes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5594 5.99886C13.5594 7.58771 12.215 8.87572 10.5566 8.87572C8.89818 8.87572 7.55378 7.58771 7.55378 5.99886C7.55378 4.40999 8.89818 3.12199 10.5566 3.12199C12.215 3.12197 13.5594 4.41001 13.5594 5.99886ZM10.562 0.00878906C8.84493 0.0164057 7.06511 0.434423 5.38028 1.23474C4.12931 1.85344 2.91018 2.72634 1.85191 3.80376C1.33215 4.35374 0.669195 5.15011 0.562012 5.99979C0.574678 6.73581 1.36418 7.64427 1.85191 8.19584C2.8443 9.23094 4.03168 10.0795 5.38028 10.7655C6.95146 11.528 8.69055 11.967 10.562 11.9914C12.2807 11.9837 14.0601 11.5609 15.7431 10.7655C16.9941 10.1468 18.2138 9.27326 19.2721 8.19584C19.7919 7.64586 20.4548 6.84947 20.562 5.99979C20.5493 5.26377 19.7598 4.35527 19.2721 3.80372C18.2797 2.76862 17.0917 1.92074 15.7431 1.23471C14.1727 0.472772 12.4294 0.0367724 10.562 0.00878906ZM10.5607 1.49626C13.1627 1.49626 15.272 3.51282 15.272 6.00044C15.272 8.48804 13.1627 10.5046 10.5607 10.5046C7.95876 10.5046 5.8495 8.48802 5.8495 6.00044C5.8495 3.51282 7.95876 1.49626 10.5607 1.49626Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShowEyes);
export default __webpack_public_path__ + "static/media/ic_show_eyes.0be987135cb9f96da9d2702f74257e1b.svg";
export { ForwardRef as ReactComponent };